export const SET_SELECTED_GIFT = 'SET_SELECTED_GIFT';
export const CREATE_GIFT_REQUEST = 'CREATE_GIFT_REQUEST';
export const CREATE_GIFT_SUCCESS = 'CREATE_GIFT_SUCCESS';
export const CREATE_GIFT_ERROR = 'CREATE_GIFT_ERROR';
